import React from "react";
import Layout from "../../components/layout";

import workersMainImage from "../../images/features-workers-main.png";
import workerFindWorkImage from "../../images/worker-find-work.png";
import workerApplyOnlineImage from "../../images/worker-apply-online.png";
import workerGetPaidImage from "../../images/worker-get-paid.png";
import workerBuildReputationImage from "../../images/worker-build-reputation.png";
import workerSafetyBuiltinImage from "../../images/worker-saftey-builtin.png";

import img1 from "../../images/feat-work-1.svg";
import img2 from "../../images/feat-work-2.svg";
import img3 from "../../images/feat-work-3.svg";
const appWorkerSignUpLink = 'https://' + process.env.GATSBY_BOH_APP_SIGNUP_WORKER;

export default () => (
	<Layout>
		<div className="features-pages page-features-employers container">
			<div className="row">
				<div className="col-12">
					<h1>Worker Benefits</h1>
					<h3 className="text-center">Find your next job fast, choose a schedule that works for you, and get paid weekly. All for free.</h3>
				</div>
				<div className="col-md-6">
					<h2>Create your free profile</h2>
					<h3>Work where and when you want</h3>
					<ul>
						<li>Create your profile on the web platform or app.</li>
						<li>Choose from 1099 or W2, remote or location-based roles.</li>
						<li>Options to work multiple jobs.</li>
						<li>Transparent details on days, times and pay rate.</li>
					</ul>
				</div>
				<div className="col-md-6">
					<img className="img img-fluid" src={img1} />
				</div>

				<div className="col-md-6">
					<img className="img img-fluid" src={img2} />
				</div>
				<div className="col-md-6">
					<h2>Get hired, get working, and get paid weekly.</h2>
					<h3>Every Friday is pay day!</h3>
					<ul>
						<li>Quick and easy to apply - get hired instantly.</li>
						<li>Try out different companies! Always get the right fit.</li>
						<li>Multiple jobs? Get one consolidated paycheck each week.</li>
						<li>Work for any company in our network whenever you want.</li>
					</ul>
				</div>

				<div className="col-md-6">
					<h2>Reap the benefits of working through Band of Hands.</h2>
					<h3>We love our people!</h3>
					<ul>
						<li>Eligible for health benefits after 60 days of full-time work.</li>
						<li>Always have instant access to newly posted jobs.</li>
						<li>Identify top employers and shine with positive work reviews and ratings.</li>
						<li>Experience employment utopia!</li>
					</ul>
				</div>
				<div className="col-md-6">
					<img className="img img-fluid" src={img3} />
				</div>
			</div>
		</div>
		<div className="row">
			<div class="section section-quotes col-12">
				<h3 className="">Ready to get hired and paid weekly? Create your free profile and find your dream job!</h3>
				<a className="btn btn-lg bg-white" href={appWorkerSignUpLink }>
					I'm ready
				</a>
			</div>
		</div>

		{/* <div id="page-features-employers">
			<div class="section section-employers-main no-margin">
				<div class="container">
					<h1 class="home-title">For Workers</h1>
					<h2 class="home-subtitle">Job flexibility with gig convenience</h2>

					<div class="main-image">
						<img class="home-center-image img-fluid" src={workersMainImage} />
					</div>
				</div>
				<img class="bg-elem img-fluid" src={employersBGElem} />
			</div>

			<div class="section section-post-ease">
				<div class="container">
					<div class="row">
						<div class="col-md-6">
							<h1>Search Work</h1>

							<h3>Explore jobs from your computer</h3>
							<h3>or mobile device.</h3>

							<ul>
								<li>Find work suited for your schedule and skill set.</li>
								<li>Get the details before you apply.</li>
								<li>Communicate and ask questions with ease.</li>
							</ul>
						</div>
						<div class="col-md-6">
							<img class="img-fluid" src={workerFindWorkImage} width="500px" />
						</div>
					</div>
				</div>
			</div>

			<div class="section section-hire-as-needed">
				<div class="container">
					<div class="row">
						<div class="col-md-6 order-2 order-md-first">
							<img class="img-fluid" src={workerApplyOnlineImage} width="500px" />
						</div>
						<div class="col-md-6">
							<h1>Apply Online</h1>


							<ul>
								<li>Use your personalized profile to get noticed and showcase your talent</li>
								<li>Check work requirements and employer reviews</li>
								<li>Apply quickly and easily</li>
							</ul>

						</div>
					</div>
				</div>
			</div>

			<div class="section section-pay-workers">
				<div class="container">
					<div class="row">
						<div class="col-md-6">
							<h1>Work and get paid</h1>

							<h3>Complete the job, submit your hours & receive weekly direct deposits</h3>

							<ul>
								<li>Connecting your bank account is secure and easy</li>
								<li>Submit your hours and get paid</li>
								<li>Track your earnings with the Band of Hands wallet</li>
							</ul>
						</div>
						<div class="col-md-6">
							<img
								class="img-fluid"
								src={workerGetPaidImage}
								// width="500px"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="section section-rep-and-safety">
				<div class="container">
					<div class="row">
						<div class="col-md-6">
							<img class="img-fluid" src={workerBuildReputationImage} />
							<h1>Build your reputation</h1>

							<p>
								Gain exposure and get hired faster on Band of Hands. Build your profile, add your skills, and import your resume.
								After every job is completed, both Employers and Workers are rated on our easy-to-use app. You can identify top
								Employers and shine with positive work reviews and ratings.
							</p>
						</div>
						<div class="col-md-6">
							<img class="img-fluid" src={workerSafetyBuiltinImage} />
							<h1>Safety Built in</h1>

							<p>
								Band of Hands cares about you and wants you to have peace of mind. When you’re hired through Band Of Hands, you are
								covered under Workers Compensation Insurance, ensuring your protection.
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="section employer-cta">
				<a class="btn btn-primary btn-big" href="/app/signup/worker">
					Sign up Today
				</a>
			</div>
		</div> */}
	</Layout>
);
